import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import PainSection from './components/PainSection';
import NotAgencySection from './components/NotAgencySection';
import ServicesSection from './components/ServicesSection';
import ExtremeMakeoverSection from './components/ExtremeMakeoverSection';
import ShowroomSection from './components/ShowroomSection';
import TestimonialsSection from './components/TestimonialsSection';
import ClientMeetingSection from './components/ClientMeetingSection';
import CTASection from './components/CTASection';
import IrresistibleOfferSection from './components/IrresistibleOfferSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import ValuesSection from './components/ValuesSection';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/bcf6558c-e91e-4119-a12c-9be3fc757e38_LOGO-02.png?v=3a69170f5d332829f533c4be3357c7ec';
const BARKY_URL = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/d6c2f9b6-4541-4f92-a27c-4e3d3602e9a5_barky_sem_fundo.png?v=6c769196e5f19b9901d880a680aabc0f';

function Footer() {
  const handleNav = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#0D2828' }} className="py-14 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt="Barkfy"
                className="h-auto object-contain flex-shrink-0"
                style={{ width: '160px' }}
              />
              <img
                src={BARKY_URL}
                alt="Barky"
                className="h-auto object-contain flex-shrink-0"
                style={{ height: '80px', width: 'auto' }}
              />
            </div>
            <p className="font-sans text-white/40 text-sm leading-relaxed" style={{ fontWeight: 300, maxWidth: '260px' }}>
              Your commercial arm across America. We close deals so you can focus on the work.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sans font-semibold text-white text-xs uppercase tracking-widest mb-5">
              <a href="#showroom">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Showroom', href: '#showroom' },
                { label: 'Our Process', href: '#meeting' },
                { label: 'Projects', href: '#projects' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="font-sans text-white/40 text-sm hover:text-[#64B4B4] transition-colors duration-300 cursor-pointer"
                    rel="nofollow"
                    style={{ fontWeight: 300 }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-sans font-semibold text-white text-xs uppercase tracking-widest mb-5">
              <a href="#contact">Contact</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="font-sans text-white/40 text-sm" style={{ fontWeight: 300 }}>601 N Magnolia Ave, Orlando, FL 32801</li>
              <li className="font-sans text-white/40 text-sm" style={{ fontWeight: 300 }}>(943) 238-4912</li>
              <li className="font-sans text-white/40 text-sm" style={{ fontWeight: 300 }}>support@barkfy.com</li>
            </ul>
          </div>
        </div>

        <div
          className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <p className="font-sans text-white/25 text-xs tracking-wider">
            &copy; {new Date().getFullYear()} Barkfy. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div
              className="w-2 h-2 rounded-full"
              style={{ background: '#64B4B4', animation: 'pulse 2s cubic-bezier(0.4,0,0.6,1) infinite' }}
            />
            <span className="font-sans text-xs tracking-widest uppercase" style={{ color: '#64B4B4' }}>
              Accepting Partners — Q2 2026
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function HomePage() {
  return (
    <main style={{ background: '#0A0A0A' }} className="min-h-screen">
      <Navbar />
      <HeroSection />
      <PainSection />
      <NotAgencySection />
      <ServicesSection />
      <ShowroomSection />
      <TestimonialsSection />
      <ExtremeMakeoverSection />
      <ClientMeetingSection />
      <CTASection />
      <IrresistibleOfferSection />
      <FAQSection />
      <ContactSection />
      <ValuesSection />
      <Footer />
    </main>
  );
}
